export enum DeliverySlug {
  Courier = 'courier',
  FastDelivery = 'fast_delivery',
  Takeaway = 'pickup',
  Pvz = 'pvz',
  TakeawayOffice = 'pick_up_point',
  Postamat = 'parcel_automat',
  Movement = 'movement',
  MovementV2 = 'movement_v2',
  OnlineDelivery = 'online',
  FastMovement = 'fast_movement',
  Equipment = 'equipment',
  Franchize = 'franchize',
  Pochta = 'pochta',
  Terminal = 'terminal',
}

export enum DeliveryPointStatus {
  NoRemains = 201,
  ChangedDate = 305,
}

export type UpdateDeliveryErrorResponse = {
  code?: DeliveryPointStatus;
  debug?: string;
  detail?: string;
  status?: number;
  type?: string;
};
